import { css } from '@emotion/react';
import type { ReactElement, ReactNode } from 'react';

import { styled } from '../../styled';
import type { Theme } from '../../theme/interface/detailed';

const commonStyles = css`
	box-sizing: border-box;
	flex-grow: 1;
	height: 100%;
	min-height: 150px;
	overflow: auto;
	width: 100%;
`;

const Component = ({ className, children }: { children: ReactNode; className: string }): ReactElement => (
	<div className={className}>{children}</div>
);

const ContentContainer = styled(Component)(
	({
		theme: {
			allSettings: {
				containers: { contentContainer },
			},
		},
	}: {
		theme: Theme;
	}) => contentContainer,
	commonStyles
);

export { ContentContainer };
